import { Component, Host, h, Prop, ComponentInterface } from '@stencil/core';
import { BodyContentOptions } from './interfaces';
import { PredefinedColors } from '../../interface';

@Component({
    tag: 'rs-content',
    styleUrl: 'content.css',
    shadow: true
})
export class Content implements ComponentInterface {
    /** (optional) 1/2 defaults to 1 */
    @Prop() body: BodyContentOptions = 1;

    /**
     * Color of the body text
     */
    @Prop() color: PredefinedColors = 'secondary';

    /**
     * display CSS rule
     */
    @Prop() display: 'block' | 'inline-block' = 'block';

    render() {
        return (
            <Host class={`body__${this.body}`}
                  style={{
                      color: this.color !== undefined ? `var(--rs-color-${this.color})` : '',
                      display: this.display
                  }}
            >
                <slot/>
            </Host>
        );
    }

}